/**
 * Extends to button checkbox
 */


Greenmile.EventLog = Greenmile.EventLog || {};
Greenmile.EventLog.ResolveInBatch = (function () {
    function ResolveInBatch () {

        Monet.Grid.ActionsModules.ButtonEventCheckBox.apply(this, arguments);

        var sendRequest = function (commentArea, scope) {
            var grid = App.Forms.EventLog.table;
            var selectedRows = grid.getItemsSelected();
            var eventLogs = [];
            var obj = {};
            obj.eventLogs = eventLogs;
            obj.comment = commentArea.value;
            scope.modalForm.toggleLoadingInModalBtn();
            
            for (var i = 0; i < selectedRows.length; i++) {
                if (!selectedRows[i].attributes.closed) {
                    var id = selectedRows[i].attributes.id;
                    eventLogs.push({ id: id });
                }
            }

            var ajax = new Monet.Ajax();
            ajax.url = 'EventLog/BatchClose';
            ajax.method = 'POST';
            ajax.data = obj;
            ajax.success = function (grid) {
                return function () {
                    App.Forms.EventLog.filterBuilder.executeFilter();
                    grid.setSelectedRows([]);
                    scope.modalForm.closeModalWindow();
                };

            }(grid);

            ajax.error = function () {
                scope.modalForm.toggleLoadingInModalBtn();
                return true;
            };

            ajax.send();

        };

        var renderContentToModal = function () {

            var modalContainer = document.querySelector('#EventLog .popupFormContainer');
            var commentContainer = document.createElement('div');
            var buttonsContainer = document.createElement('div');
            var commentArea = document.createElement('textarea');
            var form = document.createElement('form');
            var labelComment = document.createElement('label');
            var buttonSave = new Monet.UI.Fields.Button();
            var buttonCancel = new Monet.UI.Fields.Button();

            commentContainer.className = 'formCloseEvent standard-form-buttons';
            commentArea.id = 'comentario';
            commentArea.name = 'comentario';
            commentArea.setAttribute('rows', '6');
            commentArea.setAttribute('cols', '50');
            commentArea.value = '';

            buttonsContainer.className = 'formButtons';
            buttonSave.setValue(Monet.I18n.getResourcesByKey('notificationPanel.btnCloseEvent'));
            buttonCancel.setValue(Monet.I18n.getResourcesByKey('notificationPanel.btnShowCancelEvent'));

            labelComment.innerHTML = Monet.I18n.getResourcesByKey('notificationPanel.comment');

            buttonSave.input.setAttribute('style', 'float: right');
            buttonCancel.input.setAttribute('name', 'closeEventCancel_exit');
            buttonsContainer.appendChild(buttonSave.render());
            buttonsContainer.appendChild(buttonCancel.render());

            form.appendChild(labelComment);
            form.appendChild(commentArea);
            form.appendChild(buttonsContainer);
            commentContainer.appendChild(form);

            buttonSave.addEventClickListener(function (commentArea, scope) {
                return function () {
                    sendRequest(commentArea, scope);
                };
            }(commentArea, this));

            buttonCancel.addEventClickListener(function (scope) {
                return function () {
                    scope.modalForm.closeModalWindow();
                };

            }(this));

            modalContainer.appendChild(commentContainer);

        };

        this.setValueBtn = function () {
            var value = Monet.I18n.getResourcesByKey("Greenmile.EventLog.resolveInBatch");
            this.valueBtn = value;
        };

        this.openDialogToComment = function () {

            const selectedRows = App.Forms.EventLog.table.getSelectedRows();

            if (!selectedRows || !selectedRows.length) {
                new Greenmile.Components.AlertModal('Greenmile.actionGridButton.noItemChecked')
                    .show();
                return;
            }

            const options = {
                width: 280,
                height: 216
            };

            const callback = {
                onAfterShowModalForm: renderContentToModal.bind(this)
            };

            this.modalForm = new Monet.Form.Modal('#EventLog', options, callback, '#EventLog #form_and_grid');
            this.modalForm.showModalForm();


        };

        this.actionAfterClickButton = function () {

            this.openDialogToComment();

        };

    }

    return ResolveInBatch;
}());
